import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone, FileImage } from "lucide-react";
import { Button } from "@/components/ui/button";
import ParticleField from "@/components/ParticleField";
import { DOCTOR } from "@/data/content";
import { useBooking } from "@/context/BookingContext";

const HEADING_FROM = { y: 40 };
const HEADING_TO = { y: 0 };
const HEADING_VIEWPORT = { once: true };
const HEADING_TRANSITION = { duration: 0.9, ease: [0.16, 1, 0.3, 1] };

const FinalCTA = () => {
  const { openBooking } = useBooking();
  return (
    <section id="contact" data-testid="final-cta" className="relative bg-brand py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(90%_90%_at_50%_-10%,#2f74c4_0%,#1f5fa8_60%)]" />
      <div className="absolute inset-0 opacity-50">
        <ParticleField density={40} rgb="255, 255, 255" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <motion.h2
          initial={HEADING_FROM}
          whileInView={HEADING_TO}
          viewport={HEADING_VIEWPORT}
          transition={HEADING_TRANSITION}
          className="font-heading font-extrabold text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[1.02] text-balance"
        >
          Need expert spine advice?
        </motion.h2>
        <p className="mt-6 text-lg md:text-xl text-white/85 max-w-2xl mx-auto">
          Book your consultation with Dr. Arun Reddy M — daytime at CARE Hospitals, Gachibowli, or
          evenings at Indi Spine-Brain Neuro Care, Madinaguda, Hyderabad.
        </p>

        <div data-testid="cta-review-quote" className="mt-8 max-w-2xl mx-auto rounded-2xl bg-white/10 border border-white/15 px-6 py-5">
          <p className="text-white/90 italic leading-relaxed">
            &ldquo;The results have been life-changing. If you&rsquo;re looking for a surgeon you can truly trust, we highly recommend him.&rdquo;
          </p>
          <p className="mt-2 text-sm text-white/60">— Masrath A., 5&#9733; review on Google</p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row flex-wrap justify-center gap-3">
          <Button
            onClick={() => openBooking("appointment")}
            data-testid="cta-book-btn"
            className="bg-white hover:bg-slate-100 text-brand font-semibold px-7 py-6 rounded-full group"
          >
            Book Appointment
            <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
          </Button>
          <a href={`tel:${DOCTOR.phoneRaw}`} data-testid="cta-call-link">
            <Button
              variant="outline"
              className="px-7 py-6 rounded-full border-white/50 bg-transparent text-white hover:bg-white/10 hover:text-white w-full"
            >
              <Phone className="w-4 h-4 mr-1" />
              Call {DOCTOR.phone}
            </Button>
          </a>
          <Button
            onClick={() => openBooking("mri_review")}
            data-testid="cta-mri-btn"
            variant="ghost"
            className="px-6 py-6 rounded-full text-white/85 hover:text-white hover:bg-white/10"
          >
            <FileImage className="w-4 h-4 mr-1" />
            Send MRI
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
